// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__1G2i7","large":"styles_large__eva9H"};